import React from "react";

import { useData, useDataList, useDataRaw } from "@/lib/useData";
import PartLoader from "@/PartLoader";

interface PartDataProps<T> {
  url: string;
  children: (data: T | undefined) => React.ReactNode;
}

const DataProviderRaw = <T,>(props: PartDataProps<T>) => {
  // ! Added a trailing comma after <T>
  const { children, url } = props;

  const [data, loading] = useDataRaw<T>(url);

  return (
    <PartLoader block transitionDuration={250} active={loading}>
      {children(data)}
    </PartLoader>
  );
};

const DataProvider = <T,>(props: PartDataProps<T>) => {
  // ! Added a trailing comma after <T>
  const { children, url } = props;

  const [data, loading] = useData<T>(url);

  return (
    <PartLoader block transitionDuration={250} active={loading}>
      {children(data)}
    </PartLoader>
  );
};

interface PartDataListProps<T> {
  url: string;
  children: (list: T[] | undefined) => React.ReactNode;
}

const DataProviderList = <T,>(props: PartDataListProps<T>) => {
  // ! Added a trailing comma after <T>
  const { children, url } = props;

  const [data, loading] = useDataList<T>(url);

  return (
    <PartLoader block transitionDuration={250} active={loading}>
      {children(data)}
    </PartLoader>
  );
};

export { DataProvider, DataProviderList, DataProviderRaw };

export default DataProvider;
